import fb from '../../firebaseConfig';
import router from '../../router';
import Vue from 'vue';
import axios from 'axios';

let userProfileSub;

const actions = {
  subscribeToUser({ commit, state }) {
    return new Promise((resolve, reject) => {
      const userRef = fb.usersCollection.doc(state.currentUser.uid);
      userRef.get().then(docSnapshot => {
        if (docSnapshot.exists) {
          //  commit the data first
          commit('setUserProfile', docSnapshot.data());
          //  setup subscription
          userProfileSub = userRef.onSnapshot(doc => {
            var source = doc.metadata.hasPendingWrites ? 'Local' : 'Server';
            console.log('source', source);
            commit('setUserProfile', doc.data());
            //  mutlianalytics identify
            Vue.prototype.$ma.setUserProperties({
              UserId: state.currentUser.uid,
              Name: doc.data().profile.name,
              $email: doc.data().emails[0].address,
              BetaUser: true
            });
          });
          resolve('success');
        } else {
          reject();
        }
      });
    });
  },
  async getUserByEmail(undefined, emails) {
    //  Search for users by email adress. Return an array[0] with profiles if user found and array[1] with ids if user not found.
    return new Promise((resolve, reject) => {
      const url = fb.paths.function + 'getUserFromEmail';
      axios
        .post(url, { emails })
        .then(result => {
          resolve(result.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  async checkInvite({}, { inviteId }) {
    try {
      const docRef = await fb.invitesCollection.doc(inviteId).get();
      console.log(docRef);
      const invite = docRef.data();
      invite.id = docRef.id;
      console.log(invite);
      return invite;
    } catch (e) {
      throw new Error(e);
    }
  },
  async sendInvite({ state, dispatch }, { email, workspace, inviteId }) {
    console.log('send email', workspace);

    const createdOn = new Date();
    //  Create invite in db
    try {
      let id;
      if (!inviteId) {
        id = await dispatch('invites/addInviteDoc', { email, workspace }, { root: true });
        // const docRef = await fb.invitesCollection.add({
        //   createdBy: state.currentUser.uid,
        //   createdOn,
        //   toEmail: email,
        //   workspace,
        //   status: 'open' // open, accepted, denied, canceled, expired
        // });
        // id = docRef.id;
      } else {
        id = inviteId;
      }

      //  Setup email
      const fromName = state.userProfile.profile.name;
      const url = fb.paths.function + 'sendEmail';
      axios
        .post(url, {
          templateId: 1352934,
          subject: `${fromName} has invited you to Context`,
          fromName,
          email,
          workspaceName: workspace.name,
          inviteId: id
        })
        .then(result => {
          return result.data;
        })
        .catch(e => {
          throw new Error(e);
        });
    } catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },
  async checkIfUser({}, email) {
    let methods;
    let error;
    try {
      methods = await fb.auth.fetchSignInMethodsForEmail(email);
      console.log(methods);
    } catch (e) {
      methods = false;
      error = e;
    }
    return new Promise((resolve, reject) => {
      if (!methods) {
        reject(error);
      }
      const google = methods.includes('google.com');
      const password = methods.includes('password');
      resolve({ google, password });
    });
  },
  createAccountPassword({ dispatch, commit }, { name, email, password, inviteId = false }) {
    return new Promise((resolve, reject) => {
      fb.auth
        .createUserWithEmailAndPassword(email, password)
        .then(() => {
          // const user = result.user;
          // Updates the user attributes:
          fb.auth.currentUser
            .updateProfile({
              displayName: name
            })
            .then(
              function() {
                const currentUser = fb.auth.currentUser;
                // // Profile updated successfully!
                // var displayName = user.displayName;
                // // "https://example.com/jane-q-user/profile.jpg"
                // var photoURL = user.photoURL;
                commit('setCurrentUser', currentUser);
                dispatch('track/setAlias', { userId: currentUser.uid }, { root: true });
                dispatch('track/identify', { userId: currentUser.uid }, { root: true });
                dispatch('track/trackEvent', { action: 'Sign up with password' }, { root: true });
                dispatch('createNewUser', { user: currentUser, inviteId });
                resolve();
              },
              function(error) {
                // An error happened.
              }
            );
        })
        .catch(function(error) {
          // Handle Errors here.
          reject(error);
        });
    });
  },
  signInPassword({ dispatch }, { email, password }) {
    return new Promise((resolve, reject) => {
      fb.auth
        .signInWithEmailAndPassword(email, password)
        .then(result => {
          console.log(result);
          dispatch('track/identify', { userId: result.user.uid }, { root: true });
          resolve(true);
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          reject(error);
          // ...
        });
    });
  },
  signInWithGoogle({ commit, dispatch }, { inviteId = false }) {
    return new Promise((resolve, reject) => {
      var provider = new fb.providerIds.GoogleAuthProvider();
      fb.auth
        .signInWithPopup(provider)
        .then(function(result) {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;
          // The signed-in user info.
          var user = result.user;
          console.log(user);
          commit('setCurrentUser', user);

          //  Check if user exists in db
          dispatch('subscribeToUser')
            .then(() => {
              // exists, identify user to analytics
              // Vue.prototype.$ma.identify({ userId: user.user.uid });
              dispatch('track/identify', { userId: user.uid }, { root: true });
              // if (router.currentRoute.name == 'landingPage') {
              //   router.push({ name: 'dashboard' });
              // }
              resolve(true);
            })
            .catch(() => {
              //  user does not exist yet, create it
              //  Set mulianalytics identity
              dispatch('track/setAlias', { userId: user.uid }, { root: true });
              dispatch('track/identify', { userId: user.uid }, { root: true });
              // Vue.prototype.$ma.setAlias({ userId: user.user.uid });
              // Vue.prototype.$ma.identify({ userId: user.user.uid });

              //  Create user document
              dispatch('createNewUser', { user, inviteId });
            });
        })
        .catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // The email of the user's account used.
          var email = error.email;
          // The firebase.auth.AuthCredential type that was used.
          var credential = error.credential;
          reject(error);
        });
    });
  },
  createNewUser({ dispatch }, { user, inviteId }) {
    fb.usersCollection
      .doc(user.uid)
      .set({
        emails: [
          {
            address: user.email,
            verified: true //user.emailVerified
          }
        ],
        profile: {
          name: user.displayName,
          avatar: user.photoURL
        },
        collaborators: [],
        createdAt: new Date(),
        active: true,
        user: true,
        handles: {
          twitter: false,
          slack: false
        }
      })
      .then(async () => {
        try {
          console.log('subscribet o user');
          const userSub = await dispatch('subscribeToUser');
          console.log(userSub);
          //  Create a new workspace for them
          console.log('create workspace');
          const userName = user.displayName;
          let workspaceId = await dispatch(
            'workspaces/createNewWorkspace',
            { name: userName ? `${userName.split(' ')[0]}'s Workspace` : 'My Workspace' },
            { root: true }
          );
          if (inviteId) {
            //  Get the invite data
            try {
              const inviteRef = await fb.invitesCollection.doc(inviteId).get();
              const invite = inviteRef.data();
              console.log(invite);
              workspaceId = invite.workspace.id;

              //  trigger the creation of a new user workspace lite doc
              const url = fb.paths.function + 'createNewUWL';
              await axios.post(url, {
                user: { id: user.uid, name: user.displayName, avatar: user.photoUrl || false },
                workspaceId,
                addToWorkspace: true
              });
              //  update the invite
              fb.invitesCollection.doc(inviteId).update({
                status: 'accepted',
                updated_at: new Date(),
                acceptedBy: user.uid
              });
            } catch (e) {
              console.log(e);
            }
          }
          //  ensure we are subscribed to workspaces and userWorkspaceLite
          // await dispatch('workspaces/subscribeToWorkspaces', {}, { root: true });
          // await dispatch('userWorkspaceLite/subscribeToUserWorkspaceLite', {}, { root: true });

          //  set current workspace id
          dispatch('workspaces/setWorkspaceId', workspaceId, { root: true });
          //wait a second to ensure workspace is created in firebase before following up with all the other inserts
          //await new Promise(resolve => setTimeout(resolve, 500));

          // const contextId = await dispatch(
          //   'context/createNewContext',
          //   { workspaceId: workspaceId },
          //   { root: true }
          // );

          // Go to Workspace dashboard
          router.push({ name: 'dashboard', params: { workspaceId } });
        } catch (e) {
          console.log(e);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  // firebaseUiRegister({ commit, dispatch }, uiComponent) {
  //   //  chcek if we already have a AuthUI instance

  //   let ui = fb.firebaseui.auth.AuthUI.getInstance();

  //   console.log(fb);
  //   const uiConfig = {
  //     signInOptions: [
  //       {
  //         provider: fb.providerIds.GoogleAuthProvider.PROVIDER_ID,
  //         authMethod: 'https://accounts.google.com',
  //         clientId: '385146739042-4s69884pbfrp091r60i1juoios34ik7b.apps.googleusercontent.com'
  //       },
  //       {
  //         provider: fb.providerIds.EmailAuthProvider.PROVIDER_ID,
  //         requireDisplayName: true
  //       }
  //     ],
  //     //credentialHelper: fb.firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
  //     signInFlow: 'popup',
  //     callbacks: {
  //       signInSuccessWithAuthResult(user) {
  //         console.log(user);

  //         commit('setCurrentUser', user.user);

  //         //  Check if user exists in db
  //         dispatch('subscribeToUser')
  //           .then(() => {
  //             // exists, identify user to analytics
  //             // Vue.prototype.$ma.identify({ userId: user.user.uid });
  //             dispatch('track/identify', { userId: user.user.uid }, { root: true });
  //           })
  //           .catch(() => {
  //             //  user does not exist yet, create it
  //             //  Set mulianalytics identity
  //             dispatch('track/setAlias', { userId: user.user.uid }, { root: true });
  //             dispatch('track/identify', { userId: user.user.uid }, { root: true });
  //             // Vue.prototype.$ma.setAlias({ userId: user.user.uid });
  //             // Vue.prototype.$ma.identify({ userId: user.user.uid });

  //             //  Create user document
  //             fb.usersCollection
  //               .doc(user.user.uid)
  //               .set({
  //                 emails: [
  //                   {
  //                     address: user.user.email,
  //                     verified: true //user.user.emailVerified
  //                   }
  //                 ],
  //                 profile: {
  //                   name: user.user.displayName,
  //                   avatar: user.user.photoURL
  //                 },
  //                 collaborators: [],
  //                 createdAt: new Date(),
  //                 active: true,
  //                 user: true,
  //                 handles: {
  //                   twitter: false,
  //                   slack: false
  //                 }
  //               })
  //               .then(async () => {
  //                 try {
  //                   console.log('subscribet o user');
  //                   const userSub = await dispatch('subscribeToUser');
  //                   console.log(userSub);
  //                   //  Create a new workspace for them
  //                   console.log('create workspace');
  //                   const userName = user.user.displayName;
  //                   const workspaceId = await dispatch(
  //                     'workspaces/createNewWorkspace',
  //                     { name: userName ? `${userName.split(' ')[0]}'s Workspace` : 'My Workspace' },
  //                     { root: true }
  //                   );

  //                   //wait a second to ensure workspace is created in firebase before following up with all the other inserts
  //                   const timeout = await new Promise(resolve => setTimeout(resolve, 1000));

  //                   const contextId = await dispatch(
  //                     'context/createNewContext',
  //                     { workspaceId: workspaceId },
  //                     { root: true }
  //                   );

  //                   router.push({ name: 'context', params: { contextId: contextId } });
  //                 } catch (e) {
  //                   console.log(e);
  //                 }
  //               })
  //               .catch(err => {
  //                 console.log(err);
  //               });
  //           });
  //       }
  //     }
  //   };

  //   if (ui) {
  //     ui.reset();
  //   } else {
  //     ui = new fb.firebaseui.auth.AuthUI(fb.auth);
  //   }
  //   ui.start(uiComponent, uiConfig);
  // },
  sendEmailVerification() {
    const url =
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:8080/'
        : 'https://context-195220.firebaseapp.com/welcome';

    const actionCodeSettings = {
      url,
      // iOS: {
      //   bundleId: 'com.example.ios'
      // },
      // android: {
      //   packageName: 'com.example.android',
      //   installApp: true,
      //   minimumVersion: '12'
      // },
      handleCodeInApp: true
    };
    fb.auth.currentUser
      .sendEmailVerification(actionCodeSettings)
      .then(() => {
        // Verification email sent.
        console.log('email sent');
      })
      .catch(error => {
        console.log(error);
        // Error occurred. Inspect error.code.
      });
  },
  resetPassword(email) {
    return new Promise((resolve, reject) => {
      fb.auth
        .sendPasswordResetEmail(email)
        .then(() => {
          resolve();
        })
        .catch(err => {
          console.log(err);
          reject(err.reason);
        });
    });
  },
  clearData({ commit }) {
    commit('setCurrentUser', null);
    commit('setUserProfile', {
      user: false,
      emails: [],
      collaborators: [],
      handles: {},
      profile: {},
      active: null
    });
  },
  updateProfile({ state }, data) {
    return new Promise((resolve, reject) => {
      fb.usersCollection
        .doc(state.currentUser.uid)
        .update(data)
        .then(() => {
          resolve();
        })
        .catch(err => {
          console.log(err);
          reject(err.reason);
        });
    });
  },
  startCaptureSession({ state, rootState, rootGetters }, { pageId }) {
    return new Promise((resolve, reject) => {
      const workspace = rootGetters['workspaces/currentWorkspace'];
      const context = rootGetters['context/context'];
      const pages = rootState.pages.pages;
      const page = pages[pageId];
      fb.usersCollection
        .doc(state.currentUser.uid)
        .update({
          researchSession: {
            researching: true,
            workspaceId: workspace.id,
            workspaceName: workspace.profile.name,
            contextId: context.id,
            contextName: context.text,
            pageId,
            pageName: page.title,
            startDate: new Date()
          }
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          console.log(err);
          reject(err.reason);
        });
    });
  },
  stopCaptureSession({ state }) {
    return new Promise((resolve, reject) => {
      fb.usersCollection
        .doc(state.currentUser.uid)
        .update({
          researchSession: {
            researching: false,
            endDate: new Date()
          }
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          console.log(err);
          reject(err.reason);
        });
    });
  },
  logout({ dispatch }) {
    fb.auth
      .signOut()
      .then(() => {
        Vue.prototype.$ma.trackEvent({ action: 'User Logged Out' });
        Vue.prototype.$ma.reset();
        dispatch('clearData');
        userProfileSub();
        router.push('/');
      })
      .catch(err => {
        console.log(err);
      });
  }
};

export default actions;
